<template>
       <div class="container">
                <div class="page-header">
                    <div class="page-title">
                        
                        <div class="crumbs">
                            <ul id="breadcrumbs" class="breadcrumb">
                                 <li>
                                  <router-link :title="'الرئيسيه'" :to="{name: 'dashboard'}"> <i class="flaticon-home-fill"></i> الرئيسيه</router-link>
                                </li>
                                <li>
                                  <router-link :title="' الاشعارات'" :to="{name: 'parentNotifications'}"> الاشعارات</router-link>
                                </li>
                                 <li class="active">
                                  <router-link :title="'إضافة جديد'" :to="{name: 'parentNotifications.create'}">إضافة جديد</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                

                <div class="row">

                    <div class="col-lg-12 col-lg-12 col-md-12 col-sm-12 col-12  layout-spacing">
                        <div class="statbox widget box box-shadow">
                            <div class="widget-header">                                
                                <div class="row">
                                    <div class="col-xl-12 col-md-12 col-sm-12 col-12">
                                        <h4>
                                             <i class="flaticon-computer-4"></i> 
                                            بيانات الاشعارات</h4>
                                    </div>
                                </div>
                            </div>
                            <div class="widget-content widget-content-area">
                                <form @submit.prevent="store()">
                                    <div class="row">

                                      <div class="col-md-12">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">القالب</label>
                                            <treeselect :options="templates" :auto-load-root-options="true" v-model="data.form.notification_template_id" @select="getTemplate" :multiple="false"/>
                                            <div class="invalid-feedback" :style="getErrors['notification_template_id'] ? 'display: block' : 'display: none;'"   v-if="getErrors['notification_template_id']">
                                                  {{ getErrors['notification_template_id'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                      <div class="col-md-12">
                                        <div class="form-group mb-4">
                                            <label for="">المرحلة الدراسية</label>
                                            <treeselect :options="stages" v-model="data.form.stage_id" @select="getGroups" :multiple="false" />
                                            <div class="invalid-feedback" :style="getErrors['stage_id'] ? 'display: block' : 'display: none;'"  v-if="getErrors['stage_id']">
                                                  {{ getErrors['stage_id'][0] }}
                                            </div>
                                        </div>
                                      </div>
                                      <div class="col-md-12">
                                        <div class="form-group mb-4">
                                            <label for="">الصف الدراسى</label>
                                            <treeselect :options="groups" v-model="data.form.group_id" @select="loadOptionsT" :multiple="false" />
                                            <div class="invalid-feedback" :style="getErrors['group_id'] ? 'display: block' : 'display: none;'"  v-if="getErrors['group_id']">
                                                  {{ getErrors['group_id'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                      <div class="col-md-12">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">ولى الامر</label>
                                          <v-select :options="parents" v-model="user"  @search="loadOptions" @input="setNewStVal" ></v-select>

                                            <div class="invalid-feedback" :style="getErrors['user_id'] ? 'display: block' : 'display: none;'"   v-if="getErrors['user_id']">
                                                  {{ getErrors['user_id'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                        <div class="col-md-12">
                                          <label for="exampleFormControlInput12">العنوان</label>
                                          <div class="input-group mb-4">
                                              
                                              <div class="input-group-prepend">
                                                <span class="input-group-text" id="basic-addon1"><i class="flaticon-file"></i></span>
                                              </div>
                                              
                                                <input type="text" class="form-control" id="exampleFormControlInput12" v-model="data.form.title" placeholder=" العنوان ">
                                                <div class="invalid-feedback" :style="getErrors['title'] ? 'display: block' : 'display: none;'"   v-if="getErrors['title']">
                                                      {{ getErrors['title'][0] }}
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-md-12">
                                          <label for="exampleFormControlInput12">نص الاشعار</label>
                                          <div class="input-group mb-4">
                                              
                                              <textarea v-model="data.form.content" class="form-control" cols="30" rows="10"></textarea>
                                                <div class="invalid-feedback" :style="getErrors['content'] ? 'display: block' : 'display: none;'"   v-if="getErrors['content']">
                                                      {{ getErrors['content'][0] }}
                                                </div>
                                            </div>
                                        </div>

                                      </div>
                                    <button type="submit" class="save-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p"><span>حفظ</span></button>
                                    <button type="button" @click.prevent="resetForm" class="rewrite-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p"><span>تفريغ</span></button>
                                    <router-link class="back-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p" :to="{name: 'parentNotifications'}">
                                      <span>رجوع</span>
                                    </router-link>
                                                          
                                </form>
                            </div>
                        </div>
                    </div>

                </div>

            </div>

</template>
<script>
import router from '@/router'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  components: {
    Treeselect,
  },
  data() {
    return {
      parents: [],
      stages: [],
      groups: [],
      templates: [],
      user: '',
      data: {
        checker: false,
        form:{
          title: '',
          content: '',
          user_id: '',
          notification_template_id: '',
          stage_id: '',
          group_id: ''
        },
        roles: {
        },
        isRequested: false,
        errors: {},
        paginated: {}
      }
    };
  },
  created(){
    this.getRequirements();
  },
  methods: {
      getTemplate(val){
        this.$baseApi.get('/parentNotifications/create?template=1&s=' + val.id).then((response)=>{
            if(response.data.code == 200){
               this.handleTemplateData(response.data.data.template);
            }
        });
      },
      getGroups(val){
        this.loadOptionsTt(val);
      this.$baseApi.get('/parentNotifications/create?i='+val.id+'&pluckType=group').then((response)=>{
            
            if(response.data.code == 200){
              
              this.groups = response.data.data.options;
              
            }else{
                alert(response.data.error.error);
            }
        });
    },
      loadOptions(inp){
        let i = '';
        if(this.data.form.stage_id){
          i = '&type=s&i='+this.data.form.stage_id;
        }
        if(this.data.form.group_id){
          i = '&type=g&i='+this.data.form.group_id;
        }
          this.$baseApi.get('/parentNotifications/create?parent=1&s=' + inp + i).then((response)=>{
            if(response.data.code == 200){
               this.parents   = response.data.data.options;
            }
        });
      },
      loadOptionsT(val){
        let i = '&type=g&i='+val.id;
          this.$baseApi.get('/parentNotifications/create?parent=1'+ i).then((response)=>{
            if(response.data.code == 200){
               this.parents   = response.data.data.options;
            }
        });
      },
      loadOptionsTt(val){
        let i = '&type=s&i='+val.id;
          this.$baseApi.get('/parentNotifications/create?parent=1'+ i).then((response)=>{
            if(response.data.code == 200){
               this.parents   = response.data.data.options;
            }
        });
      },
      setNewStVal(val){
        this.data.form.user_id = val.id;
      },
      resetForm(){
        this.data.form = {
          title: '',
          content: '',
          user_id: '',
          notification_template_id: '',
          stage_id: '',
          group_id: ''
        };
      },
      store(){
          this.data.isRequested = true;
         this.$baseApi.post('/parentNotifications', this.data.form).then((response)=>{
            if(response.data.code === 200){
              localStorage.setItem('flash_message', 'تمت عملية الاضافة');
                router.push('/parentNotifications');
            }
        }).catch((error) => {
            this.data.errors = JSON.parse(JSON.stringify(error.response.data.errors));
            this.data.isRequested = false
          })
      },
      handleTemplateData(data){
        this.data.form.title = data.title;
        this.data.form.content = data.content;
      },
      getRequirements(){
         this.getOptions();
      },
      getOptions(){
        this.$baseApi.get('/parentNotifications/create').then((response)=>{
            if(response.data.code == 200){
              console.log(response.data.data)
               this.templates = response.data.data.templates;
               this.parents   = response.data.data.parents;
               this.stages   = response.data.data.stages;
               this.groups   = response.data.data.groups;
            }
        });
      },
      
  },
  computed: {
    trans(){
      return this.$store.getters.GET_TRANS;
    },
    user(){
      return this.$store.getters.SET_AUTH_USER;
    },
    getErrors() {
      return JSON.parse(JSON.stringify(this.data.errors))
    },
  }
};
</script>
<style>
</style>
